(function () {
  if (window.realestStickyZoomInitialized) return;
  window.realestStickyZoomInitialized = true;

  const desktopPointer = window.matchMedia(
    "(min-width: 750px) and (hover: hover) and (pointer: fine)"
  );

  let label;

  function hideLabel() {
    if (label) {
      label.style.opacity = "0";
    }
  }

  function createLabel() {
    if (label && label.isConnected) return;

    label = document.createElement("div");
    label.className = "zoom-cursor-label";
    label.textContent = "+zoom.";
    label.setAttribute("aria-hidden", "true");

    Object.assign(label.style, {
      position: "fixed",
      pointerEvents: "none",
      zIndex: "9999",
      fontSize: "11px",
      fontWeight: "400",
      letterSpacing: "-0.02em",
      textTransform: "lowercase",
      color: "#fff",
      mixBlendMode: "difference",
      opacity: "0",
      transition: "opacity 0.2s ease",
      transform: "translate(-50%, -50%)",
      whiteSpace: "nowrap"
    });

    document.body.appendChild(label);
  }

  function initializeThumbnails() {
    document
      .querySelectorAll(".media-gallery__sticky-thumbs")
      .forEach(function (container) {
        if (container.dataset.realestThumbsReady === "true") {
          return;
        }

        const buttons = Array.from(
          container.querySelectorAll("button")
        );

        const gridWrapper = container.closest(
          ".media-gallery__with-thumbs"
        );

        const gridItems = Array.from(
          gridWrapper?.querySelectorAll(".media-gallery__grid li") || []
        );

        if (!buttons.length || !gridItems.length) return;

        container.dataset.realestThumbsReady = "true";

        buttons.forEach(function (button) {
          button.style.display = "block";
          button.style.opacity = "0.5";
        });

        const visibleCount = 5;

        function setActive(index) {
          buttons.forEach(function (button, buttonIndex) {
            const active = buttonIndex === index;

            button.classList.toggle("is-active", active);
            button.style.opacity = active ? "1" : "0.5";
            button.style.transform = active
              ? "scale(1)"
              : "scale(0.95)";
          });

          const thumbHeight = 64 * (2 / 3) + 6;
          const maxOffset =
            Math.max(0, buttons.length - visibleCount) * thumbHeight;
          const offset = Math.min(index * thumbHeight, maxOffset);

          container.style.transition = "transform 0.3s ease";
          container.style.transform =
            "translateY(-" + offset + "px)";
        }

        setActive(0);

        buttons.forEach(function (button, index) {
          button.addEventListener("click", function () {
            const target = document.getElementById(
              button.dataset.target
            );

            if (target) {
              target.scrollIntoView({
                behavior: window.matchMedia(
                  "(prefers-reduced-motion: reduce)"
                ).matches
                  ? "instant"
                  : "smooth",
                block: "start"
              });
            }

            setActive(index);
          });
        });

        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              const index = buttons.findIndex(function (button) {
                return button.dataset.target === entry.target.id;
              });

              if (index !== -1) {
                setActive(index);
              }
            });
          },
          {
            root: null,
            rootMargin: "0px",
            threshold: 0.4
          }
        );

        gridItems.forEach(function (item) {
          observer.observe(item);
        });

        const galleryObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              container.style.transition =
                "opacity 0.3s ease, transform 0.3s ease";

              container.style.opacity = entry.isIntersecting
                ? "1"
                : "0";

              container.style.pointerEvents = entry.isIntersecting
                ? "auto"
                : "none";
            });
          },
          {
            threshold: 0.01
          }
        );

        if (gridWrapper) {
          galleryObserver.observe(gridWrapper);
        }
      });
  }

  function initialize() {
    createLabel();
    initializeThumbnails();
  }

  document.addEventListener("pointermove", function (event) {
    if (
      !desktopPointer.matches ||
      !(event.target instanceof Element)
    ) {
      hideLabel();
      return;
    }

    if (document.querySelector("dialog[open]")) {
      hideLabel();
      return;
    }

    const imageContainer = event.target.closest(
      ".product-media-container--image"
    );

    const gallery = imageContainer?.closest(
      "media-gallery, .media-gallery"
    );

    if (!imageContainer || !gallery) {
      hideLabel();
      return;
    }

    createLabel();

    label.style.left = event.clientX + "px";
    label.style.top = event.clientY + "px";
    label.style.opacity = "1";
  });

  document.documentElement.addEventListener(
    "pointerleave",
    hideLabel
  );

  document.addEventListener("pointerdown", hideLabel);
  window.addEventListener("blur", hideLabel);
  window.addEventListener("resize", hideLabel);

  document.addEventListener("shopify:section:load", function () {
    hideLabel();
    initialize();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, {
      once: true
    });
  } else {
    initialize();
  }
})();
